import { createApp } from 'vue'
import App from './App.vue'
import store from './store/vuex'
import router from './router'

import { createHead } from '@vueuse/head' // <-- добавлено

import '@/assets/scss/tailwind.scss'
import "@/assets/libs/@mdi/font/css/materialdesignicons.min.css"
import '@/assets/libs/tobii/css/tobii.min.css'
import VueEasyLightbox from 'vue-easy-lightbox'
import VueAwesomePaginate from "vue-awesome-paginate";
import "vue-awesome-paginate/dist/style.css";
import { createPinia } from 'pinia'
import { useAuthStore } from '../src/auth'

const app = createApp(App)

const head = createHead() // <-- создаем экземпляр

const pinia = createPinia()

app.use(head) // <-- подключаем
app.use(VueEasyLightbox)
app.use(VueAwesomePaginate)
app.use(store)
app.use(pinia)

const auth = useAuthStore()

auth.initToken()

app.use(router)

app.mount('#app')

    